import { getTestIds } from 'seagull/utils/TestIds';
export const AttachmentsTestIds = getTestIds('AttachmentsTestIds');